/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class CreateScreenFromTemplateMutation extends Relay.Mutation {

    static propTypes = {
        channelDef_id: PropTypes.string.isRequired,
        channelEntityDef_id: PropTypes.string.isRequired,
        channel_id: PropTypes.string.isRequired,
        operation: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
        scenarioScreenDef: PropTypes.object,
        screenDef: PropTypes.object,
        subOperation: PropTypes.string,
        usedScenario: PropTypes.object,
    };

    static fragments = {
    };

    getMutation() {
        return Relay.QL`mutation {createScreenFromTemplate}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on CreateScreenFromTemplatePayload @relay(pattern: true) {
                clientMutationId,
                updatedNode {
                    id,
                    realId,
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel_id,
            channelDef_id: this.props.channelDef_id,
            channelEntityDef_id: this.props.channelEntityDef_id,
            operation: this.props.operation,
            subOperation: this.props.subOperation,
            organisation_id: this.props.organisation_id,
            scenarioScreenDef_id: this.props.scenarioScreenDef ? this.props.scenarioScreenDef.id : null,
            scenarioDef_id: this.props.scenarioScreenDef ? this.props.scenarioScreenDef.scenarioDef_id : null,
            scenario_id: this.props.usedScenario ? this.props.usedScenario.scenario_id : null,
            usedScenario_id: this.props.usedScenario ? this.props.usedScenario.id : null,
            screenDef_id: this.props.screenDef ? this.props.screenDef.id : null,
        };
    }
}
